import useTypedContext from "hooks/useTypedContext";
import { hasAtLeastReadAccess } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const useHasSpaceReadAccess = (spaceId?: string) => {
  const { viewer } = useTypedContext(AccountContext);

  if (!spaceId) {
    return false;
  }

  return hasAtLeastReadAccess(viewer, spaceId);
};

export default useHasSpaceReadAccess;
